import styled from 'styled-components'

export const FieldOkMark = styled.span`
  position: absolute;
  right: -31px;
  top: 28px;
`
